// Shared colour language for calendar event types and boards

export const TYPE_STYLES = {
  open: {
    dot: 'bg-emerald-500',
    badge: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    cell: 'bg-emerald-100 text-emerald-800 hover:bg-emerald-200',
    chip: 'bg-emerald-50 text-emerald-700 hover:bg-emerald-100',
    tile: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  },
  close: {
    dot: 'bg-orange-500',
    badge: 'bg-orange-50 text-orange-700 border-orange-200',
    cell: 'bg-orange-100 text-orange-800 hover:bg-orange-200',
    chip: 'bg-orange-50 text-orange-700 hover:bg-orange-100',
    tile: 'bg-orange-50 text-orange-700 border-orange-200',
  },
  allotment: {
    dot: 'bg-sky-500',
    badge: 'bg-sky-50 text-sky-700 border-sky-200',
    cell: 'bg-sky-100 text-sky-800 hover:bg-sky-200',
    chip: 'bg-sky-50 text-sky-700 hover:bg-sky-100',
    tile: 'bg-sky-50 text-sky-700 border-sky-200',
  },
  holiday: {
    dot: 'bg-slate-400',
    badge: 'bg-slate-100 text-slate-600 border-slate-200',
    cell: 'bg-slate-200 text-slate-600',
    chip: 'bg-slate-100 text-slate-600',
    tile: 'bg-slate-100 text-slate-600 border-slate-200',
  },
};

export const BOARD_STYLES = {
  mainboard: { label: 'Mainboard', badge: 'bg-teal-50 text-[#006666] border-teal-200' },
  sme: { label: 'SME', badge: 'bg-amber-50 text-amber-700 border-amber-200' },
};

// Colour a whole day by its most time-sensitive event
const DOMINANCE = ['holiday', 'close', 'open', 'allotment'];

export const dominantType = (events) => DOMINANCE.find((type) => events.some((event) => event.type === type)) || null;
